// Single source of truth for Security Hub finding severity styling, aligned to
// the CloudKeeper palette + pastel-triad chip language used across the portal.
// (Previously the same severity was coloured three different ways — here, in
// Overview.js and ComplianceDashboard.js — so identical severities rendered in
// different reds/oranges. Those now import from here.)
//   CRITICAL = red, HIGH = orange, MEDIUM = amber, LOW = blue, INFORMATIONAL = grey
export const SEVERITY_COLORS = {
  CRITICAL: '#E74C3C',
  HIGH: '#E67E22',
  MEDIUM: '#F39C12',
  LOW: '#4698D3',
  INFORMATIONAL: '#999999',
};

export const severityColor = (s) =>
  SEVERITY_COLORS[String(s || '').toUpperCase()] || SEVERITY_COLORS.INFORMATIONAL;

// Pastel-triad chip styling for a severity value (matches statusChipSx).
export const severityChipSx = (s) => {
  const c = severityColor(s);
  return {
    height: 24,
    fontSize: '0.75rem',
    fontFamily: 'Metropolis, sans-serif',
    fontWeight: 600,
    backgroundColor: `${c}14`,
    color: c,
    border: `1px solid ${c}33`,
  };
};

// Neutral pastel-triad chip for workflow status / record state.
export const stateChipSx = {
  height: 24,
  fontSize: '0.75rem',
  fontFamily: 'Metropolis, sans-serif',
  fontWeight: 600,
  backgroundColor: '#F5F5F5',
  color: '#999999',
  border: '1px solid #E5E5E5',
};
